import axios from 'axios';
import { HOST_API } from 'src/config-global';
import { endpoints } from 'src/utils/api-endpoints';

export function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken: string): boolean => {
  if (!accessToken) return false;
  const decoded = jwtDecode(accessToken);
  return decoded.exp > Date.now() / 1000;
};

export async function getLatestAccessToken(): Promise<string | null> {
  try {
    const res = await axios.post(
      `${HOST_API}${endpoints.auth.refreshToken}`,
      {},
      { withCredentials: true }
    );
    return res.data?.accessToken ?? null;
  } catch {
    return null;
  }
}

export const setLocalStorage = (userData: unknown | null) => {
  if (!userData) {
    localStorage.removeItem('userData');
  }
};